import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {filterArticle_template} from "./filterArticle_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterWebsiteUser_template} from "./filterWebsiteUser_template";
import { addClass } from "@amcharts/amcharts4/core";
import { filterTag_template } from "./filterTag_template";

declare var ko: any;

export class websiteUserCommentList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected brandFilter: filterDropdown_template;
    protected statusFilter: multipleSelector_template;
    protected dateFilter: filterDate_template;
    protected articleFilter: filterArticle_template;
    protected isPinnedFilter: multipleSelector_template;
    protected isReplyFilter: multipleSelector_template;
    protected filterPreset: filterPreset_template;
    protected commentStatusTooltip : infoButton_template;
    protected commentPinnedTooltip : infoButton_template;
    protected toxicityTestTooltip : infoButton_template;
    protected userFilter: filterWebsiteUser_template;
    protected commentTypeFilter: filterDropdown_template;
    protected tagFilter: filterTag_template;
    protected isEmakiUserFilter: multipleSelector_template;
    protected isEditedFilter: multipleSelector_template;
    protected hasMentionsFilter: multipleSelector_template;
    protected isManuallyModeratedFilter: multipleSelector_template;
    protected containsImagesFilter: multipleSelector_template;
    protected imageStatusFilter: multipleSelector_template;
    protected commentsPerPageFilter: filterDropdown_template;
    protected updateStatuses: filterDropdown_template;
    protected imageStatusTooltip : infoButton_template;

    protected getTemplateHtml(): string {

        return /* html */ `
            <div class="sub-header filter-preset w-justify"> ${this.filterPreset.getHtmlBuild()} </div>

            <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        <div class="form-group">
                            <label class="form-label form-label-box">Brand</label>
                            ${this.brandFilter.getHtmlBuild()}
                        </div>
                        <div class="form-group">
                            <label class="form-label form-label-box">Comment Type</label>
                            ${this.commentTypeFilter.getHtmlBuild()}
                        </div>
                        <div> ${this.statusFilter.getHtmlBuild()} </div>
                        <div> ${this.imageStatusFilter.getHtmlBuild()} </div>
                        <div> ${this.containsImagesFilter.getHtmlBuild()} </div>
                        <div> ${this.isManuallyModeratedFilter.getHtmlBuild()} </div>
                        <div> ${this.isEmakiUserFilter.getHtmlBuild()} </div>
                        <div> ${this.isReplyFilter.getHtmlBuild()} </div>
                        <div> ${this.hasMentionsFilter.getHtmlBuild()} </div>
                        <div> ${this.isPinnedFilter.getHtmlBuild()} </div>
                        <div> ${this.isEditedFilter.getHtmlBuild()} </div>
                        <div> ${this.dateFilter.getHtmlBuild()} </div>
                        <!-- ko if: commentType() === 'article_comments' -->
                            <div> ${this.articleFilter.getHtmlBuild()} </div>
                        <!-- /ko -->
                        <!-- ko if: commentType() === 'tag_reviews' -->
                            <div> ${this.tagFilter.getHtmlBuild()} </div>
                        <!-- /ko -->
                        <div> ${this.userFilter.getHtmlBuild()} </div>


                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brands"></div>
                    <div id="selected-statuses"></div>
                    <div id="selected-image-statuses"></div>
                    <div id="selected-containsImages"></div>
                    <div id="selected-isReply"></div>
                    <div id="selected-hasMentions"></div>
                    <div id="selected-isPinned"></div>
                    <div id="selected-articles"></div>
                    <div id="selected-users"></div>
                    <div id="selected-isEmakiUser"></div>
                    <div id="selected-isEdited"></div>
                    <div id="selected-isManuallyModerated"></div>
                </div>
            </div>

            <div class="list-header w-justify" >
                <div class="w-left">

                    <label>test</label>
                    <button data-bind="event: { click: onClickToggleToxicityDialogVisibility }" class="btn secondary icon i-article">test</button>
                    <button data-bind="event: { click: onClickToggleImageDialogVisibility }" class="btn secondary icon i-image" style="display:none; margin: 0;">test</button>

                    <div class="d-inline-flex">
                        <div class="border-left apply" data-bind="css: { 'is-disable': selectedCount() === 0}">
                            <label class="form-label">Bulk Action</label>
                            ${(this.updateStatuses.getHtmlBuild())}
                        </div>

                        <button class="btn highlight left-join icon i-check"
                            type="button"
                            data-bind="css: { 'is-disable': selectedCount() === 0 },
                                event: { click: onClickUpdate },
                                html: (selectedCount() === 0) ? 'Apply' : 'Apply To <br>' + selectedCount() + ' Selected Comments'">
                        </button>

                    </div>
                </div>
                <div class="w-center"> ${this.filter.getHtmlBuild()} </div>

                <div class="w-right">
                    <button
                        style="margin: 10px"
                        data-bind="click : onClickExportToCSV , css: { 'is-disable': exportInProgress }, text : exportTextBox"
                        class="btn secondary icon i-export" type="button">
                    </button>
                    <div>
                        <label class="form-label form-label-box">Rows</label>
                        ${this.commentsPerPageFilter.getHtmlBuild()}
                    </div>
                    ${this.pagination.getHtmlBuild()}
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th>
                                <div style="display: flex;justify-content: center;">
                                    <input type="checkbox" id="selectAll" value="checked" data-bind="checked: selectAllChecked, event: {click: setAllChecked}" >
                                    <label style="" for="selectAll" class="form-label icon i-check"></label>
                                </div>
                            </th>
                            <th class="align-right"><span>Edit</span></th>
                            <!-- ko if: showBrandColumn -->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brandName') }, css: { 'list-sort-desc': orderByAndDirection()=='brandName_DESC', 'list-sort-asc': orderByAndDirection()=='brandName_ASC' }">Brand</span></th>
                            <!-- /ko -->
                            <th><span style="width: 375px;" class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'commentText') }, css: { 'list-sort-desc': orderByAndDirection()=='commentText_DESC', 'list-sort-asc': orderByAndDirection()=='commentText_ASC' }">Comment</span></th>
                            <th class="align-right"><span>Image</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'upvotes') }, css: { 'list-sort-desc': orderByAndDirection()=='upvotes_DESC', 'list-sort-asc': orderByAndDirection()=='upvotes_ASC' }">↑</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'downvotes') }, css: { 'list-sort-desc': orderByAndDirection()=='downvotes_DESC', 'list-sort-asc': orderByAndDirection()=='downvotes_ASC' }">↓</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'statusName') }, css: { 'list-sort-desc': orderByAndDirection()=='statusName_DESC', 'list-sort-asc': orderByAndDirection()=='statusName_ASC' }">Comment<br>Status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'imageStatusName') }, css: { 'list-sort-desc': orderByAndDirection()=='imageStatusName_DESC', 'list-sort-asc': orderByAndDirection()=='imageStatusName_ASC' }">Image<br>Status</span></th>
                            <th style="padding-right: 2rem;"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'moderatorName') }, css: { 'list-sort-desc': orderByAndDirection()=='moderatorName_DESC', 'list-sort-asc': orderByAndDirection()=='moderatorName_ASC' }">Moderator</span></th>
                            <!-- ko if: commentType() === 'article_comments' -->
                                <th style="padding-right: 2rem;"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleTitle') }, css: { 'list-sort-desc': orderByAndDirection()=='articleTitle_DESC', 'list-sort-asc': orderByAndDirection()=='articleTitle_ASC' }">Article</span></th>
                            <!-- /ko -->
                            <!-- ko if: commentType() === 'tag_reviews' -->
                                <th style="padding-right: 2rem;"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tagName') }, css: { 'list-sort-desc': orderByAndDirection()=='tagName_DESC', 'list-sort-asc': orderByAndDirection()=='tagName_ASC' }">Tag</span></th>
                                <th style="padding-right: 2rem;"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'rating') }, css: { 'list-sort-desc': orderByAndDirection()=='rating_DESC', 'list-sort-asc': orderByAndDirection()=='rating_ASC' }">Rating</span></th>
                            <!-- /ko -->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'displayName') }, css: { 'list-sort-desc': orderByAndDirection()=='displayName_DESC', 'list-sort-asc': orderByAndDirection()=='displayName_ASC' }">Website User</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isEmakiUser') }, css: { 'list-sort-desc': orderByAndDirection()=='isEmakiUser_DESC', 'list-sort-asc': orderByAndDirection()=='isEmakiUser_ASC' }">Emaki</br>User</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idParent') }, css: { 'list-sort-desc': orderByAndDirection()=='idParent_DESC', 'list-sort-asc': orderByAndDirection()=='idParent_ASC' }">Reply</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'mentionCount') }, css: { 'list-sort-desc': orderByAndDirection()=='mentionCount_DESC', 'list-sort-asc': orderByAndDirection()=='mentionCount_ASC' }">Mentions</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isPinned') }, css: { 'list-sort-desc': orderByAndDirection()=='isPinned_DESC', 'list-sort-asc': orderByAndDirection()=='isPinned_ASC' }">Pinned</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateSubmitted') }, css: { 'list-sort-desc': orderByAndDirection()=='dateSubmitted_DESC', 'list-sort-asc': orderByAndDirection()=='dateSubmitted_ASC' }">Submitted</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateEdited') }, css: { 'list-sort-desc': orderByAndDirection()=='dateEdited_DESC', 'list-sort-asc': orderByAndDirection()=='dateEdited_ASC' }">Edited</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Updated</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'moderationReason') }, css: { 'list-sort-desc': orderByAndDirection()=='moderationReason_DESC', 'list-sort-asc': orderByAndDirection()=='moderationReason_ASC' }">System Moderator</span></th>
                            <th class="align-right"><span>Delete</span></th>
                        </tr>
                    </thead>

                    <tbody data-bind="foreach: comments">

                        <tr  class="cursor">
                            <td class="checkbox">
                                <div>
                                    <input type="checkbox" value="checked" data-bind="checked: checked, value: id, attr:{id: 'comment_' + id}, click: $parent.onClickChecked"/>
                                    <label data-bind="text: name, attr:{for: 'comment_' + id}" class="form-label icon i-check"></label>
                                </div>
                            </td>

                            <td><button type="button" data-bind="event: { click: $parent.onClickShowPopUp }, clickBubble: false" class="btn border only-icon icon i-edit"></button></td>
                            <!-- ko if: $parent.showBrandColumn -->
                            <td class="brands"><a><span class="dark" data-bind="css: brandIconImage"></span></a></td>
                            <!-- /ko -->
                            <td><a><span class="t-comment" data-bind="html: commentText"></span></a></td>
                            <td><a>
                            <!-- ko if: imageUrl != null -->
                                <img class="comment-upload" data-bind="attr: { src: imageUrl }"/>
                            <!-- /ko -->
                            </a></td>
                            <td><a><span data-bind="text: upvotes ? upvotes : 0"></span></a></td>
                            <td><a><span data-bind="text: downvotes ? downvotes : 0"></span></a></td>
                            <td>
                                <a><span data-bind="text: statusName"></span></a>
                            </td>
                            <td><a><span data-bind="text: imageStatusName"></span></a></td>
                            <td><a><span data-bind="text: $data.moderatorName"></span></a></td>
                            <!-- ko if: $parent.commentType() === 'article_comments' -->
                                <td >
                                    <div class="flex">
                                        <a><span class="title" style="padding-left: 0" data-bind="text: articleTitle"></span></a>
                                        <a><span class="btn icon border only-icon i-link" data-bind="visible : $data['template'] !== 'Sub-Content' , event: { click: $parent.onClickViewOnSite }, attr: { id : 'site-view' + $data.id }"></span></a>
                                    </div>
                                </td>
                            <!-- /ko -->
                            <!-- ko if: $parent.commentType() === 'tag_reviews' -->
                                <td><a><span data-bind="text: tagName"></span></a></td>
                                <td><a><span data-bind="text: rating"></span></a></td>
                            <!-- /ko -->
                            <td>
                                <div class="flex" >
                                    <a class="title" style="width: 100px;">
                                    <div class="flex premium-user">
                                        <span data-bind="text: displayName ? displayName : brandShortName + 'Member', css: { user: isAccessPointUserActive, 'user-deactivated': !isAccessPointUserActive }"></span><br>
                                        <!-- ko if: isPremium -->
                                            <img class="premuim-indic" src="../assets/images/premuim-indic.svg" alt="">
                                        <!-- /ko -->
                                    </div>
                                        <span data-bind="text: '(#' + idProfile + ')', css: { user: isAccessPointUserActive, 'user-deactivated': !isAccessPointUserActive }"></span>
                                    </a>
                                    <a><span class="btn icon border only-icon i-link" data-bind="visible : $data['template'] !== 'Sub-Content' , event: { click: $parent.onClickViewWebsiteUser }, attr: { idWebsiteUser : $data.idWebsiteUser }"></span></a>

                                </div>
                            </td>
                            <td><a><span data-bind="text: isEmakiUser == 1 ? 'Yes' : 'No'"></span></a></td>
                            <td><a><span data-bind="text: idParent ? 'Yes' : 'No'"></span></a></td>
                            <td><a><span data-bind="text: mentionCount"></span></a></td>
                            <td><a><span data-bind="text: isPinned == 0 ? 'No' : 'Yes'"></span></a></td>
                            <td><a><span class="no-wrap" data-bind="text: dateSubmitted"></span></a></td>
                            <td><a><span class="no-wrap" data-bind="text: dateEdited"></span></a></td>
                            <td><a><span class="no-wrap" data-bind="text: dateUpdated"></span></a></td>
                            <td><a><span class="no-wrap" data-bind="text: moderationReason"></span></a></td>
                            <td>
                                <button class="btn border highlight only-icon icon i-delete" data-bind="event: { click: $parent.onClickDelete }" type="button" ></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="check-toxicity-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">

                        <div class="form-header">
                            <h3 class="form-title icon i-check">Test Comment Toxicity</h3>
                            <button type="button"  data-bind="event: { click: onClickToggleToxicityDialogVisibility }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                            <!-- <div class="w-tooltips-adv pos-top mini"> ${this.toxicityTestTooltip.getHtmlBuild()} </div> -->
                                <p class="form-text">Test individual comment toxicity without commenting on the website by using the text field below. Toxicity will be scored between 0 and 1, with 1 being the most toxic. Only comments with a toxicity score below 0.2 will be approved.</p>

                            </div>
                            <div class="form-group">
                                <textarea type="textarea" class="input-text" placeholder="Enter comment here" data-bind="value: testCommentToxicity" /></textarea>
                            </div>

                            <div class="form-group">
                                <p class="form-text" data-bind="html: testCommentToxicityResultMessage"></p><br>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button data-bind="event: { click: onClickToggleToxicityDialogVisibility }" class="btn">Close</button>
                            <button data-bind="event: { click: onClickCheckToxicity }" class="btn highlight">Test</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ko if: false -->
            <div id="image-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">

                        <div class="form-header">
                            <h3 class="form-title icon i-check">Test Image Appropriateness</h3>
                            <button type="button"  data-bind="event: { click: onClickToggleImageDialogVisibility }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body" id="image-form-body">
                            <div class="form-group">
                                <p class="form-text">Test individual image appropriateness without commenting on the website by using the image field below. Scores between 0 and 1 will be returned, with 1 being the most aligned with a concept. Drug, explicit, gore, safe, and suggestive are the tested concepts.</p>

                            </div>
                            <div class="form-group">

                                <input type="file" accept=".jpg,.jpeg,.png,.x-png,.gif,.webp" data-bind="event: { change:onClickUploadImage }">
                            </div>

                            <div class="form-group">
                                <p class="form-text" data-bind="html: testImageResults"></p><br>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button data-bind="event: { click: onClickToggleImageDialogVisibility }" class="btn">Close</button>
                            <button data-bind="event: { click: onClickCheckImage }, css: { 'is-disable': testImageUrl() == null }" class="btn highlight">Test</button>
                            </div>
                    </div>
                </div>
            </div>
            <!-- /ko -->

            <div id="edit-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">

                    <div class="w-form w-form-large lightbox-form" style="width: 100%">
                        <div class="form-header">
                            <h3 class="form-title">Edit Comment</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>
                        <div class="w-form-body" data-bind="if: commentToEdit() !== null" style="max-height: 500px;overflow-y: scroll;">
                            <div class="form-body">
                                <div class="form-group row">
                                    <label class="form-label" style="display: flex">
                                        Status
                                        <div class="w-tooltips-adv pos-right short"> ${this.commentStatusTooltip.getHtmlBuild()} </div>
                                    </label>
                                    <div class="form-comment-status">
                                        <select style="width: 100%;margin-bottom:1.5rem;" data-bind="value: idEditStatus, selected: commentToEdit().status, options: statusOptions, optionsText: 'name', optionsValue: 'id'"></select>
                                    </div>
                                </div>
                                <div class="form-group comment-edit">

                                    <label class="form-label" data-bind="visible: commentToEdit().parentCommentText">Parent Comment </label>
                                    <p class="form-text" style="width:350px;white-space: pre-wrap;word-break: break-word;"  data-bind="html: commentToEdit().parentCommentText ? commentToEdit().parentCommentText : ''"></p>
                                </div>
                                <div class="form-group row">
                                    <label class="form-label" >Comment</label>
                                    <div style="width:350px;white-space: pre-wrap;word-break: break-word;" data-bind="html: commentToEdit().commentText"></div>
                                </div>

                                <div class="form-group">
                                   <hr class="form-hr" />
                                </div>
                                <div class="form-group row" style="width: fit-content;">
                                    <input type="checkbox" id="pinned-comment" name="pinned-comment" data-bind="checked: isPinnedEdit">
                                    <label for="pinned-comment" style="padding-block:0;"  class="form-label icon i-check">Pinned Comment</label>
                                    <div class="w-tooltips-adv pos-right short"> ${this.commentPinnedTooltip.getHtmlBuild()} </div>
                                </div>
                            </div>

                        <div class="form-body">
                            <div class="form-group row">
                                <label class="form-label" style="display: flex">
                                    Image Status
                                    <div class="w-tooltips-adv pos-left short"> ${this.imageStatusTooltip.getHtmlBuild()} </div>
                                </label>
                                    <div class="form-comment-status">
                                        <select style="width: 100%;margin-bottom:1.5rem;" data-bind="value: idEditImageStatus, selected: commentToEdit().idImageStatus, options: imageStatusOptions, optionsText: 'name', optionsValue: 'id'"></select>
                                    </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label" >Image </label>
                                <!-- ko if: commentToEdit().imageUrl != null -->
                                    <img class="comment-upload" data-bind="attr: { src: commentToEdit().imageUrl }"/>
                                <!-- /ko -->
                                <!-- ko ifnot: !!commentToEdit().imageUrl -->
                                    <p class="form-text">none</p>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>
                        </div>
                    </div>

                </div>
            </div>
            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.brandFilter = new filterDropdown_template("brandFilter", this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel("Brands");

        this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setLabel("Comment Status");
        this.statusFilter.setFilterContainerClass('margin-neg');
        this.statusFilter.setTagContainerId('selected-statuses');
        this.statusFilter.setTagContainerCaption('Selected statuses:');

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.getTemplateViewModel().startDate(null);
        this.dateFilter.getTemplateViewModel().endDate(null);
        this.dateFilter.getTemplateViewModel().hmsEnabled(true);
        this.dateFilter.toggleClearButton(true);
        this.dateFilter.setLabel('Date Range');

        this.articleFilter = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);
        this.articleFilter.setShowDetails(true);
        this.articleFilter.setIsLoadingAnimationEnable(true);


        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);

        this.isPinnedFilter = new multipleSelector_template("isPinnedFilter", this.getTemplateViewModel(), this.caller);
        this.isPinnedFilter.setLabel("Is Pinned");
        this.isPinnedFilter.setFilterContainerClass('margin-neg');
        this.isPinnedFilter.setTagContainerId('selected-isPinned');
        this.isPinnedFilter.setTagContainerCaption('Selected Is Pinned:');

        this.isReplyFilter = new multipleSelector_template("isReplyFilter", this.getTemplateViewModel(), this.caller);
        this.isReplyFilter.setLabel("Is Reply");
        this.isReplyFilter.setFilterContainerClass('margin-neg');
        this.isReplyFilter.setTagContainerId('selected-isReply');
        this.isReplyFilter.setTagContainerCaption('Selected Is Reply:');

        this.containsImagesFilter = new multipleSelector_template("containsImagesFilter", this.getTemplateViewModel(), this.caller);
        this.containsImagesFilter.setLabel("Contains Images");
        this.containsImagesFilter.setFilterContainerClass('margin-neg');
        this.containsImagesFilter.setTagContainerId('selected-containsImages');
        this.containsImagesFilter.setTagContainerCaption('Selected Contains Images:');

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('commentList');

        this.commentStatusTooltip = new infoButton_template('commentStatusTooltip', this.getTemplateViewModel(), this.caller)
        this.commentStatusTooltip.setTitle('Comment Status');
        let commentStatusTooltipText = `
        <ul>
            <li>Comments with the "Submitted" and "Pending Review" status are only visible on the website to the user that commented it.
                <ul>
                    <li>"Submitted" comments are queued for automatic moderation by the system (using word filter and toxicity verification).</li>
                    <li>"Pending Review" comments await manual moderation (system moderation not applied).</li>
                </ul>
            </li>
            <li>Approved comments are visible publicly on the website.</li>
            <li>Rejected comments are not visible publicly on the website.</li>
        </ul>`;
        this.commentStatusTooltip.setContent(commentStatusTooltipText);

        this.commentPinnedTooltip = new infoButton_template('commentPinnedTooltip', this.getTemplateViewModel(), this.caller)
        this.commentPinnedTooltip.setTitle('Pinned Comment');
        let commentPinnedTooltipText = `<p>Pin a comment to keep it on the top of the comment list.</p>`;
        this.commentPinnedTooltip.setContent(commentPinnedTooltipText);

        this.toxicityTestTooltip = new infoButton_template('toxicityTestTooltip', this.getTemplateViewModel(), this.caller)
        this.toxicityTestTooltip.setTitle('Toxicity Test');
        let toxicityTestTooltipText = `
            <p>Test individual comment toxicity without commenting on the website by using the text field below.
            Toxicity will be scored between 0 and 1, with 1 being the most toxic. Only comments with a toxicity score below 0.2 will be approved.</p>
        `;
        this.toxicityTestTooltip.setContent(toxicityTestTooltipText);

        this.userFilter = new filterWebsiteUser_template("userFilter", this.getTemplateViewModel(), this.caller);
        this.userFilter.asMultipleSelectionMode();
        this.userFilter.setTagContainerId('selected-users');
        this.userFilter.setTagContainerCaption('Selected users:');
        this.userFilter.setPlaceholderText("User");
        this.userFilter.setUniqueIdentifier("userId");

        this.commentTypeFilter = new filterDropdown_template("commentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.commentTypeFilter.setLabel("Comment Type");
        this.commentTypeFilter.setOptions([
            { id: 'article_comments', name: 'Article Comments' },
            { id: 'tag_reviews', name: 'Tag Reviews' },
        ]);

        this.isEmakiUserFilter = new multipleSelector_template("isEmakiUserFilter", this.getTemplateViewModel(), this.caller);
        this.isEmakiUserFilter.setLabel("Is Emaki User");
        this.isEmakiUserFilter.setFilterContainerClass('margin-neg');
        this.isEmakiUserFilter.setTagContainerId('selected-isEmakiUser');
        this.isEmakiUserFilter.setTagContainerCaption('Selected Is Emaki User:');

        this.isEditedFilter = new multipleSelector_template("isEditedFilter", this.getTemplateViewModel(), this.caller);
        this.isEditedFilter.setLabel("Is Edited");
        this.isEditedFilter.setFilterContainerClass('margin-neg');
        this.isEditedFilter.setTagContainerId('selected-isEdited');
        this.isEditedFilter.setTagContainerCaption('Selected Is Edited:');

        this.hasMentionsFilter = new multipleSelector_template("hasMentionsFilter", this.getTemplateViewModel(), this.caller);
        this.hasMentionsFilter.setLabel("Has Mentions");
        this.hasMentionsFilter.setFilterContainerClass('margin-neg');
        this.hasMentionsFilter.setTagContainerId('selected-hasMentions');
        this.hasMentionsFilter.setTagContainerCaption('Selected Has Mentions:');
        this.hasMentionsFilter.setItems([
            {id: 1, name: 'Yes'},
            {id: 0, name: 'No'}
        ]);

        this.isManuallyModeratedFilter = new multipleSelector_template("isManuallyModeratedFilter", this.getTemplateViewModel(), this.caller);
        this.isManuallyModeratedFilter.setLabel("Is Manually Moderated");
        this.isManuallyModeratedFilter.setFilterContainerClass('margin-neg');
        this.isManuallyModeratedFilter.setTagContainerId('selected-isManuallyModerated');
        this.isManuallyModeratedFilter.setTagContainerCaption('Selected Is Manually Moderated:');

        this.imageStatusFilter = new multipleSelector_template("imageStatusFilter", this.getTemplateViewModel(), this.caller);
        this.imageStatusFilter.setLabel("Image Status");
        this.imageStatusFilter.setFilterContainerClass('margin-neg');
        this.imageStatusFilter.setTagContainerId('selected-image-statuses');
        this.imageStatusFilter.setTagContainerCaption('Selected image statuses:');

        this.updateStatuses = new filterDropdown_template("updateStatuses", this.getTemplateViewModel(), this.caller);
        this.updateStatuses.setDisable(true);

        this.commentsPerPageFilter = new filterDropdown_template("commentsPerPageFilter", this.getTemplateViewModel(), this.caller);
        this.commentsPerPageFilter.setOptions([
            { id: 25, name: '25' },
            { id: 50, name: '50' },
            { id: 100, name: '100' },
        ]);

        this.imageStatusTooltip = new infoButton_template('imageStatusTooltip', this.getTemplateViewModel(), this.caller)
        this.imageStatusTooltip.setTitle('Image Status');
        let imageStatusTooltipText = `
        <ul>
            <li>Images with the "Submitted" and "Pending Review" status are only visible on the website to the user that commented it. .
                <ul>
                    <li>"Submitted" images are queued for automatic moderation by the system (using appropriateness verification).</li>
                    <li>"Pending Review" images await manual moderation (system moderation not applied).</li>
                </ul>
            </li>
            <li>Approved images are visible publicly on the website.</li>
            <li>Rejected images are not visible publicly on the website.</li>
        </ul>`;
        this.imageStatusTooltip.setContent(imageStatusTooltipText);
    }

    protected getTemplateName(): string {

        return "websiteUserCommentList_template";
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            orderBy: ko.observable("dateSubmitted"),
            orderByDirection: ko.observable("DESC"),
            comments: ko.observableArray([]),
            orderByAndDirection: ko.observable("dateSubmitted_DESC"),
            commentToEdit: ko.observable(null),
            statusOptions: ko.observableArray([]),
            isPinnedOptions: ko.observableArray([]),
            idEditStatus: ko.observable(null),
            idEditImageStatus: ko.observable(null),
            isPinnedEdit: ko.observable(false),
            isReplyOptions: ko.observableArray([]),
            imageStatusOptions: ko.observableArray([]),
            containsImagesOptions: ko.observableArray([]),
            testCommentToxicity: ko.observable(null),
            testCommentToxicityResultMessage: ko.observable(null),
            commentType: ko.observable('article_comments'),
            showBrandColumn: ko.observable(false),
            selectedCount: ko.observable(0),
            selectAllChecked: ko.observable(false),
            lastClickedComment: ko.observable(null),
            testImageUrl: ko.observable(null),
            testImageResults: ko.observable(null),
            exportInProgress : ko.observable(false),
            exportTextBox : ko.observable("Export to CSV"),

            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickShowPopUp : (data, event) =>{
                self.onClickShowPopUp(data)
            },
            onClickHidePopUp : (data, event) =>{
                self.onClickHidePopUp()
            },
            onClickSave : (data, event) =>{
                self.onClickSave()
            },
            onClickViewOnSite: (data, event) => {
                self.onClickViewOnSite(data);
            },
            onClickCheckToxicity: (data, event) => {
                self.onClickCheckToxicity();
            },
            onClickToggleToxicityDialogVisibility: (data, event) => {
                self.toggleCheckToxicityDialogVisibility();
            },
            onClickToggleImageDialogVisibility: (data, event) => {
                self.toggleImageDialogVisibility();
            },
            onClickCheckImage: (data, event) => {
                self.onClickCheckImage();
            },
            onClickViewWebsiteUser: (data, event) => {
                self.onClickViewWebsiteUser(data);
            },
            onClickUploadImage: (data, event) => {
                self.uploadImage(data,  event);
            },
            onClickDelete: (value, data, event) => {
                self.onClickDelete(value);
            },
            onClickUpdate: this.onClickUpdate.bind(this),
            setAllChecked: this.setAllChecked.bind(this),
            onClickChecked: this.onClickChecked.bind(this),
            onClickExportToCSV : (data) => {
                self.onClickExportToCSV(data);
            }
        };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {
        const tagObj = this.tagFilter.getTagObj();
        let idTag = null;
        let tagName = null;

        if (tagObj) {
            idTag = tagObj.id;
            tagName = tagObj.name;
        }

        let numberOfCommentsPerPage = this.commentsPerPageFilter.getSelectedOption();
        const commentsPerPageFilterOptions = this.commentsPerPageFilter.getOptions();
        if(commentsPerPageFilterOptions.indexOf(numberOfCommentsPerPage) == -1){
            numberOfCommentsPerPage = commentsPerPageFilterOptions[0];
        }
        this.pagination.getTemplateViewModel().itemPerPage = numberOfCommentsPerPage.id;

        const sortingOptions = this.getSortingOptions();
        return {
            orderBy: sortingOptions.orderBy,
            orderByDirection: sortingOptions.orderByDirection,
            orderByAndDirection: sortingOptions.orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType(),
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                brandId : this.getTemplateViewModel().brandFilter.selectedOption,
                statusIds : this.getTemplateViewModel().statusFilter.selectedItems,
                isPinned : this.getTemplateViewModel().isPinnedFilter.selectedItems,
                isEmakiUser : this.isEmakiUserFilter.getSelectedItems(),
                isEdited : this.isEditedFilter.getSelectedItems(),
                hasMentions: this.hasMentionsFilter.getSelectedItems(),
                isManuallyModerated : this.isManuallyModeratedFilter.getSelectedItems(),
                commentsPerPage: numberOfCommentsPerPage.id,
                users : this.userFilter.getUsersForRequest(),
                selectedArticle: this.getTemplateViewModel().filterArticle.articleObj(),
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                isReply: this.getTemplateViewModel().isReplyFilter.selectedItems,
                imageStatusIds : this.getTemplateViewModel().imageStatusFilter.selectedItems,
                containsImages: this.getTemplateViewModel().containsImagesFilter.selectedItems,
                commentType: this.getTemplateViewModel().commentTypeFilter.selectedOption(),
                idTag: idTag,
                tagName: tagName
            },
        }
    }

    public setTestImageUrl(url){

        this.getTemplateViewModel().testImageUrl(url);
    }

    public setTestImageResults(results){

        var resultHTML = '<p class="form-text">Drug: <strong>' + results.drug.toFixed(2) + '</strong></p>';

        resultHTML += '<p class="form-text">Explicit: <strong>' + results.explicit.toFixed(2) + '</strong></p>';

        resultHTML += '<p class="form-text">Gore: <strong>' + results.gore.toFixed(2) + '</strong></p>';

        resultHTML += '<p class="form-text">Safe: <strong>' + results.safe.toFixed(2) + '</strong></p>';

        resultHTML += '<p class="form-text">Suggestive: <strong>' + results.suggestive.toFixed(2) + '</strong></p>';

        resultHTML += '<p class="form-text">The image would be marked as <strong>' + results.status + '</strong></p>';

        this.getTemplateViewModel().testImageResults(resultHTML);
    }

    public getViewModelForSave(){

        return {
            commentToEdit: this.getTemplateViewModel().commentToEdit,
            idEditStatus: this.getTemplateViewModel().idEditStatus,
            idEditImageStatus: this.getTemplateViewModel().idEditImageStatus,
            isPinnedEdit: this.getTemplateViewModel().isPinnedEdit
        }
    }

    public getViewModelForToxicityCheck(){

        return {
            testCommentToxicity: this.getTemplateViewModel().testCommentToxicity
        }
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.commentListReorder();
    }

    public onClickEdit(id) {

        this.caller.editUserProfile(id);
    }

    public setComments(comments): void {
        comments.forEach(comment => {
            comment.checked = !!comment.checked;
        })

        this.getTemplateViewModel().comments([]);
        this.getTemplateViewModel().comments(comments);
        this.setSelectedCount();
    }

    protected getComments() {
        return this.getTemplateViewModel().comments();
    }

    public showActiveUsers() {

        this.caller.onShowActiveUsers();
        return true;
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setBrands(brands){

        brands.unshift({id: 0, name: "All"});
        this.brandFilter.setOptions(brands);
    }

    public setStatuses(statuses){

        this.statusFilter.setItems(statuses);
        this.getTemplateViewModel().statusOptions(statuses);
    }

    public setImageStatuses(imageStatuses){

        this.imageStatusFilter.setItems(imageStatuses);
        this.getTemplateViewModel().imageStatusOptions(imageStatuses);
    }

    public setIsPinnedOptions(isPinnedOptions){
        this.isPinnedFilter.setItems(isPinnedOptions);
        this.getTemplateViewModel().isPinnedOptions(isPinnedOptions);
    }

    public setIsReplyOptions(isReplyOptions){
        this.isReplyFilter.setItems(isReplyOptions);
        this.getTemplateViewModel().isReplyOptions(isReplyOptions);
    }

    public setContainsImagesOptions(containsImagesOptions){
        this.containsImagesFilter.setItems(containsImagesOptions);
        this.getTemplateViewModel().containsImagesOptions(containsImagesOptions);
    }

    public setSearchPresets(presets){

        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){

        this.filterPreset.addCreatedPresetToList(response);
    }

    public setUpdateStatuses(status): void {

        this.updateStatuses.setOptions(status);
    }

    public setSelectedCount() {

        let selectedCount = 0;

        let comments = this.getComments();

        comments.forEach(comment => {
            selectedCount += comment.checked ? 1 : 0;
        });

        this.getTemplateViewModel().selectedCount(selectedCount);
        this.updateStatuses.setDisable(selectedCount === 0);
    }

    protected getSelectedCount() {
        return this.getTemplateViewModel().selectedCount();
    }

    public onClickUpdate() {

        let comments = this.getComments();
        let ids = [];

        comments.forEach(comment => {
            if (comment.checked) {
                ids.push(comment.id);
            }
        });

        this.caller.updateComments(ids, this.updateStatuses.getSelectedOption().id);
    }

    public setSelectAllChecked(selectAllValue: boolean) {
        this.getTemplateViewModel().selectAllChecked(selectAllValue);
        this.setAllChecked();
    }

    public getSelectAllChecked() {
        return this.getTemplateViewModel().selectAllChecked();
    }

    public setAllChecked() {

        let selectAllValue = this.getSelectAllChecked();

        let comments = this.getComments();

        comments.forEach(comment => {
            comment.checked = selectAllValue;
        })

        this.setLastClickedComment(null);
        this.setComments(comments);

        return true;
    }

    public onClickChecked(data, event) {
        let comments = this.getComments();

        const lastClickedComment = this.getLastClickedComment();
        this.setLastClickedComment(data);

        if(event.shiftKey && lastClickedComment && data != lastClickedComment){
            const indexOfLastClickedComment = comments.indexOf(lastClickedComment);
            const indexOfClickedComment = comments.indexOf(data);
            const min = Math.min(indexOfLastClickedComment, indexOfClickedComment);
            const max = Math.max(indexOfLastClickedComment, indexOfClickedComment);
            for(let i = min; i <= max; i++){
                comments[i].checked = lastClickedComment.checked;
            }
        }

        this.setComments(comments);

        return true;
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            //Set option for brandId
            if (urlParams.brandId){
                this.brandFilter.setSelectedOption(urlParams.brandId);
            } else {
                this.brandFilter.setSelectedOption(0);
            }

            // Set option for comments per page
            if (urlParams.commentsPerPage) {
                this.commentsPerPageFilter.setSelectedOption(urlParams.commentsPerPage);
            } else {
                this.commentsPerPageFilter.setSelectedOption(25);
            }

            this.setFilterSelectedItems(this.statusFilter, urlParams.statusIds);

            // date filters.
            if(urlParams.dateFilterType){
                this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if(urlParams.startDateRange || urlParams.endDateRange){

                this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }

            if(urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            if(urlParams.users){
                this.userFilter.setSelectedUsersFromRequestParams(urlParams.users);
            } else {
                this.userFilter.resetTagContainer();
            }

            if(urlParams.commentType){
                this.setCommentTypeFilterValue(urlParams.commentType);
            }

            if(urlParams.commentType == "tag_reviews" && urlParams.idTag){
                this.tagFilter.setTag({ id: urlParams.idTag, name: urlParams.tagName });
            }

            if(urlParams.commentType == "article_comments" && urlParams.selectedArticle){
                this.articleFilter.setSelectedArticle(urlParams.selectedArticle);
            }

            if (urlParams.hasMentions) {
                this.setFilterSelectedItems(this.hasMentionsFilter, urlParams.hasMentions);
            }

            // keyword filter.
            let keywordString = urlParams.keywords
            if(urlParams.keywords){
                keywordString = urlParams.keywords.replaceAll("+", " ");
            }
            this.filter.getTemplateViewModel().filterKeyword(keywordString);

            this.setFilterSelectedItems(this.imageStatusFilter, urlParams.imageStatusIds);

            this.setFilterSelectedItems(this.containsImagesFilter, urlParams.containsImages);
            this.setFilterSelectedItems(this.isManuallyModeratedFilter, urlParams.isManuallyModerated);
            this.setFilterSelectedItems(this.isEmakiUserFilter, urlParams.isEmakiUser);
            this.setFilterSelectedItems(this.isReplyFilter, urlParams.isReply);
            this.setFilterSelectedItems(this.isPinnedFilter, urlParams.isPinned);
            this.setFilterSelectedItems(this.isEditedFilter, urlParams.isEdited);
        }
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams !== null && urlParams !== undefined){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else if(Array.isArray(urlParams)){
                splitString = urlParams;
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    private setDateFilters(startDate, endDate) {

        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }

    public onClickShowPopUp(data){

        let clone = data;
        this.getTemplateViewModel().commentToEdit(clone);
        this.getTemplateViewModel().idEditStatus(clone.idStatus);
        this.getTemplateViewModel().idEditImageStatus(clone.idImageStatus ? clone.idImageStatus : 2);
        this.getTemplateViewModel().isPinnedEdit(clone.isPinned == 1);
        this.toggleEditDialogVisibility();
    }

    public onClickHidePopUp(){

        this.getTemplateViewModel().commentToEdit(null);
        this.getTemplateViewModel().idEditStatus(null);
        this.getTemplateViewModel().idEditImageStatus(null);
        this.getTemplateViewModel().isPinnedEdit(false);
        this.toggleEditDialogVisibility();
    }

    public onClickSave(){

        this.caller.editComment();
    }

    public toggleEditDialogVisibility() {

        document.getElementById('edit-dialog').classList.toggle('is-visible');
    }

    public toggleCheckToxicityDialogVisibility() {

        document.getElementById('check-toxicity-dialog').classList.toggle('is-visible');
        this.getTemplateViewModel().testCommentToxicity(null);
        this.getTemplateViewModel().testCommentToxicityResultMessage(null);
    }

    public toggleImageDialogVisibility() {

        document.getElementById('image-dialog').classList.toggle('is-visible');
    }

    public setDefaults(){

        // date filters.
        this.dateFilter.getTemplateViewModel().selectedFilter("range");
        this.dateFilter.setRange("-30d", null);
    }

    public onClickViewOnSite(data){

        let domain = data.brandDomain;
        let permalink = data.articlePermalink;
        this.caller.viewArticleOnSite(permalink, domain);
        return false;
    }

    public onClickViewWebsiteUser(data){

        this.caller.viewWebsiteUser(data);
    }


    public uploadImage(data, event){

        this.caller.uploadImage(data, event);
    }

    public onClickDelete(data){

        if(confirm('Are you sure you want to delete the selected comment(s)? This action is irreversible.')){
            this.caller.deleteComment(data.id);
        }
    }

    public onClickCheckToxicity(){

        let testCommentToxicity = this.getTemplateViewModel().testCommentToxicity();
        this.caller.checkToxicity(testCommentToxicity);
        return false;
    }

    public onClickCheckImage(){

        let testImageUrl = this.getTemplateViewModel().testImageUrl();
        this.caller.checkImageAppropriateness(testImageUrl);
        return false;
    }

    public setToxicityScoreResultMessage(score){

        if (!score || isNaN(score)) {
            let message = "An error has occured when trying to check the toxicity of the comment.";
            this.getTemplateViewModel().testCommentToxicityResultMessage(message);
            return;
        }

        let message = "The comment has received a toxicity score of " + score.toFixed(4) + ", which would be ";

        if(score < 0.2){
            message += "<span class=" + '"alert-success"' + "><span class=" + '"only-icon icon i-circle"'+ ">Approved.</span></span>";

        }else{
            message += "<span class=" + '"alert-error"' + "><span class=" + '"only-icon icon i-circle"' + ">Rejected.</span></span>";

        }

        this.getTemplateViewModel().testCommentToxicityResultMessage(message);
    }

    public setArticlesFilter(articles) {

        this.getTemplateViewModel().filterArticle.showDetails(false);
        this.getTemplateViewModel().filterArticle.showBrand(true);
        this.getTemplateViewModel().filterArticle.articles(articles);
    }

    public setUserFilter(users) {

        this.userFilter.setUsers(users);
    }

    public setCommentTypeFilterValue(commentTypeFilter = 'article_comments') {

        if (['article_comments', 'tag_reviews'].indexOf(commentTypeFilter) === -1) {
            commentTypeFilter = 'article_comments';
        }

        this.setLastClickedComment(null);
        this.setComments([]);
        this.commentTypeFilter.setSelectedOption(commentTypeFilter);
        this.getTemplateViewModel().commentType(commentTypeFilter);
    }

    protected setTagFilter(tags) {
        this.tagFilter.setTags(tags);
    }

    public setIsEmakiUsersOptions(options) {
        this.isEmakiUserFilter.setItems(options);
    }

    public setIsEditedOptions(options) {
        this.isEditedFilter.setItems(options);
    }

    public setIsManuallyModeratedOptions(options) {
        this.isManuallyModeratedFilter.setItems(options);
    }

    public getSelectedBrandOption() {
        return this.brandFilter.getSelectedOption();
    }

    public setShowBrandColumn(showBrandColumn) {
        this.getTemplateViewModel().showBrandColumn(showBrandColumn);
    }

    public getSortingOptions() {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
        }
    }

    protected setLastClickedComment(comment) {
        this.getTemplateViewModel().lastClickedComment(comment);
    }

    protected getLastClickedComment() {
        return this.getTemplateViewModel().lastClickedComment();
    }

    public handleBrandColumnDisplay() {

        let selectedBrandOption = this.getSelectedBrandOption();
        let showBrandColumn = !(selectedBrandOption && selectedBrandOption.id != 0);
        this.setShowBrandColumn(showBrandColumn);

        this.userFilter.setDisabled(showBrandColumn);
        this.articleFilter.setDisableField(showBrandColumn);
    }

    onClickExportToCSV(data){
        this.getTemplateViewModel().exportInProgress(true);
        this.getTemplateViewModel().exportTextBox("Exporting ...");
        const {filters} = this.getViewModelForRequest();
        this.caller.exportToCSV(data, filters);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/websiteUserCommentList_template.ts